import { render, staticRenderFns } from "./Shareholders.vue?vue&type=template&id=519d16dd"
import script from "./Shareholders.vue?vue&type=script&lang=js"
export * from "./Shareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports